<template>
  <el-card
      class="item-card"
      shadow="never"
      style="border-radius: 4px !important; border: 1px solid #dee5ec;"
      body-style="margin: 0px;">
    <div
        class="flex flex-row"
        style="margin: 8px 24px 8px 8px">
      <div
          class="flex-1"
          style="margin: 8px">
        <div
            class="flex flex-row"
            style="margin: 0px 0px 8px 0px">
          <div class="flex-1">
            <strong>Delivery Address</strong>
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            Name
          </div>
          <div class="item-price">
            {{ customerData.customer_name }}
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            Phone number
          </div>
          <div class="item-price">
            {{ customerData.customer_phone }}
          </div>
        </div>
        <div class="flex flex-row">
          <div
              class="flex-1"
              style="margin: 0px 0px 24px 0px">
            Email
          </div>
          <div class="item-price">
            {{ customerData.customer_email }}
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            Street
          </div>
          <div class="item-price">
            {{ billingAddress.address_1 }}
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            City
          </div>
          <div class="item-price">
            {{ billingAddress.city }}
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            State/province/area
          </div>
          <div class="item-price">
            {{ billingAddress.state }}
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            Zip code
          </div>
          <div class="item-price">
            {{ billingAddress.zip }}
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            Country
          </div>
          <div class="item-price">
            {{ billingAddress.country }}
          </div>
        </div>
        <div style="margin: 0px 0px 24px 0px"></div>
        <div style="border: 1px solid #DEE5EC;"></div>
        <div style="margin: 24px 0px 0px 0px"></div>
        <div
            class="flex flex-row"
            style="margin: 0px 0px 16px 0px">
          <div class="flex-1">
            <strong>Billing Address</strong>
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            Name
          </div>
          <div class="item-price">
            {{ customerData.customer_name }}
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            Phone number
          </div>
          <div class="item-price">
            {{ customerData.customer_phone }}
          </div>
        </div>
        <div class="flex flex-row">
          <div
              class="flex-1"
              style="margin: 0px 0px 24px 0px">
            Email
          </div>
          <div class="item-price">
            {{ customerData.customer_email }}
          </div>
        </div>
        <div
            v-if="billingAddress != shippingAddress"
            class="flex flex-row">
          <div class="flex-1">
            Street
          </div>
          <div class="item-price">
            {{ shippingAddress.address_1 }}
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            City
          </div>
          <div class="item-price">
            {{ shippingAddress.city }}
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            State/province/area
          </div>
          <div class="item-price">
            {{ shippingAddress.state }}
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            Zip code
          </div>
          <div class="item-price">
            {{ shippingAddress.zip }}
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            Country
          </div>
          <div class="item-price">
            {{ shippingAddress.country }}
          </div>
        </div>
        <div
            v-if="billingAddress===shippingAddress"
            class="flex flex-row">
          <div class="flex-1">
            Same as Delivery Address
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
export default {
  name: "CustomerDetailsItemView",
  props: {
    customerData: {
      type: Object,
      default: () => {
        return [];
      },
    },
    billingAddress: {
      type: Object,
      default: () => {
        return [];
      },
    },
    shippingAddress: {
      type: Object,
      default: () => {
        return [];
      },
    },
    name: {
      type: String,
      default: "NA",
    },
    phonenumber: {
      type: String,
      default: "NA",
    },
    email: {
      type: String,
      default: "NA",
    },
    street: {
      type: String,
      default: "NA",
    },
    city: {
      type: String,
      default: "NA",
    },
    area: {
      type: String,
      default: "NA",
    },
    zipcode: {
      type: String,
      default: "NA",
    },
    country: {
      type: String,
      default: "NA",
    },
  },
  data() {
    return {
      same: true,
    };
  },
  computed: {},
};
</script>

<style>
.item-name {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #424242;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.item-asin {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: flex-end;
  color: #6e6e6e;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  margin-top: 2px;
}

.item-status {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  flex: none;
  order: 1;
  flex-grow: 1;
  margin-top: 14px;
  color: #f1670d;
}

.item-status-shipped {
  color: #178019 !important;
}

.item-status-pending {
  color: #f1670d !important;
}

.item-status-cancelled {
  color: #d4231a !important;
}

.item-price {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  text-align: right;
  color: #424242;
  flex: none;
  order: 1;
  flex-grow: 0;
}
</style>
